import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../../api/store";
import { defaultAmountByRider, SINGLE_RIDER_IDS_COVERAGE, SINGLE_RIDER_IDS_DISEASE, SINGLE_RIDER_IDS_GCI_DENGUE_MOSQUITO, SINGLE_RIDER_IDS_GCI_TOP4, SINGLE_RIDER_IDS_GCIR } from "../../../../constant/gms-constant";
import { AddRiderUniformCoverageInputPayload, UniformCoverageState } from "./coverage-type-uniform-coverage.state";

const initialState: UniformCoverageState = {
    selectedUniformCoverage: null,
    riders: [],
};

const uniformCoverageSlice = createSlice({
    name: "uniformCoverageSlice",
    initialState,
    reducers: {
        setSelectedUniformCoverage: (state, action: PayloadAction<{ label: string; value: string | number; }>) => {
            let rawValue = String(action.payload.value).replace(/[^0-9.]/g, "");
            const parts = rawValue.split(".");
            if (parts.length > 2) {
                rawValue = parts[0] + "." + parts[1];
            }
            const numericValue = Number(rawValue) || 0; 
            state.selectedUniformCoverage = {
                label: action.payload.label,
                fAmount: numericValue,
            };
            state.riders.forEach(rider => {
                rider.rider.fAmount = numericValue;
            });
        },
        addRiderUniformCoverageInput: (state, action: PayloadAction<AddRiderUniformCoverageInputPayload[]>) => {
            const selectedLabel = state.selectedUniformCoverage?.label ?? "";
            state.riders = action.payload.map(r => ({
                ...r,
                rider: {
                    ...r.rider,
                    label: selectedLabel 
                }
            }));
        },
        addOrUpdateUniformCoverageRider: (state, action: PayloadAction<{ id: number; label: string}>) => {
            const { id, label } = action.payload;
            const selectedLabel = state.selectedUniformCoverage?.label ?? "";
            const selectedFAmount = state.selectedUniformCoverage?.fAmount ?? 0;
        
            const singleSelectGroup: number[] = SINGLE_RIDER_IDS_COVERAGE;
            const singleSelectGCIR: number[] = SINGLE_RIDER_IDS_GCIR;
            const singleSelectDisease: number[] = SINGLE_RIDER_IDS_DISEASE;

            const singleSelectGCI_TOP4: number[] = SINGLE_RIDER_IDS_GCI_TOP4;
            const singleSelectGCI_DENGUE_MOSQUITO: number[] = SINGLE_RIDER_IDS_GCI_DENGUE_MOSQUITO;
            
            if (singleSelectGroup.includes(id)) {
                state.riders = state.riders?.filter(
                    r => !singleSelectGroup.includes(r.id)
                ) || [];
            }

            if (singleSelectGCIR.includes(id)) {
                state.riders = state.riders?.filter(
                    r => !singleSelectGCIR.includes(r.id)
                ) || [];
            }

            if (singleSelectDisease.includes(id)) {
                state.riders = state.riders?.filter(
                    r => !singleSelectDisease.includes(r.id)
                ) || [];
            }
            // GCI
            if (singleSelectGCI_TOP4.includes(id)) {
                state.riders = state.riders?.filter(
                    r => !singleSelectGCI_TOP4.includes(r.id)
                ) || [];
            }
            if (singleSelectGCI_DENGUE_MOSQUITO.includes(id)) {
                state.riders = state.riders?.filter(
                    r => !singleSelectGCI_DENGUE_MOSQUITO.includes(r.id)
                ) || [];
            }
            
            const existing = state.riders.find(r => r.id === id);

            if (existing) {
                existing.rider.label = selectedLabel;
            } else {
                state.riders.push({
                    id,
                    label,
                    rider: {
                        fAmount: defaultAmountByRider[Number(id)] ?? selectedFAmount,
                        label: selectedLabel
                    }
                });
            }
        },
        removeRiderUniformCoverageInput: (state, action: PayloadAction<number>) => {
            state.riders = state.riders.filter(r => r.id !== action.payload);
        },
        updateRiderUniformCoverageAmount: (state, action: PayloadAction<{ riderId: number; fAmount: number }>) => {
            const { riderId, fAmount } = action.payload;

            const riderItem = state.riders.find(r => r.id === riderId);
            if (!riderItem) return;

            riderItem.rider.fAmount = fAmount;
        },
        resetUniformCoverage: () => ({
            selectedUniformCoverage: null,
            riders: [],
        }),
    },
});

export const { 
    setSelectedUniformCoverage, 
    resetUniformCoverage, 
    addRiderUniformCoverageInput,
    updateRiderUniformCoverageAmount,
    removeRiderUniformCoverageInput,
    addOrUpdateUniformCoverageRider
} = uniformCoverageSlice.actions;

export const selectUniformCoverage = (state: RootState) => state.uniformCoverageSlice.selectedUniformCoverage;
export const selectUniformCoverageRiders = (state: RootState) => state.uniformCoverageSlice.riders;

export default uniformCoverageSlice.reducer;